import { Link } from "@repo/ui/Link/routerLink";
import type { FC, ReactNode } from "react";
import alpharunLogomarkBlackUrl from "../assets/alpharunLogomarkBlack.svg";
import { useHideAlpharunBranding } from "../helpers/fountain.js";
import { UserProfileWidgetContainer } from "./navigation/userProfileWidgetContainer.js";
import { WorkspaceBackLink } from "./navigation/workspaceBackLink.js";
import type { WorkspaceId } from "./navigation/workspaces.js";
import { WorkspaceSwitcherContainer } from "./navigation/workspaceSwitcherContainer.js";

export interface AppNavigationProps {
  currentWorkspaceId?: WorkspaceId;
  backHref?: string;
  children?: ReactNode;
}

export const AppNavigation: FC<AppNavigationProps> = (props) => {
  const hideAlpharunBranding = useHideAlpharunBranding();

  return (
    <div className="flex h-full flex-col gap-3 px-1 pb-1">
      {hideAlpharunBranding ? null : (
        <div className="flex h-11 flex-none items-center">
          <Link
            href="/"
            aria-label="Go to homepage"
            className="flex h-full w-fit items-center rounded-md px-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <img
              src={alpharunLogomarkBlackUrl}
              alt="Alpharun"
              className="h-4 text-sidebar-foreground"
            />
          </Link>
        </div>
      )}

      {props.currentWorkspaceId ? (
        <WorkspaceSwitcherContainer
          currentWorkspaceId={props.currentWorkspaceId}
        />
      ) : props.backHref ? (
        <WorkspaceBackLink href={props.backHref} />
      ) : null}
      {/* Padding keeps focus rings clear of the scroll clip edge; the matching
          negative margin cancels it so the column's gap sets the real spacing. */}
      <div className="-m-1 min-h-0 flex-auto overflow-auto p-1">
        {props.children}
      </div>
      <UserProfileWidgetContainer />
    </div>
  );
};
